module.exports = __webpack_public_path__ + "static/media/master-card-icon-32x20.584e5a4f.svg";